import styled from 'styled-components'

// Takes the height left by the Drawer's own toolbar.
export const DrawerThreadBoxStyled = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
`
